import { useNavigate, useParams } from 'react-router-dom';
import { useGetCompetitionsQuery } from 'src/api/competitions/getCompetitions';
import {
  Button,
  Card,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Iconify from '../../components/iconify';
import { LanguageTabs } from '../../components/language-tabs';
import { TabPanel } from '../../components/language-tabs/TabPanel';
import { visibleLanguages } from '../../config/quill-text-editor-settings';
import { CompetitionType } from '../../types/domain.types';
import { useState } from 'react';
import { useCreateCompetitionMutation } from '../../api/competitions/createCompetition';
import { useUpdateCompetitionMutation } from '../../api/competitions/updateCompetition';
import { useForm } from '@tanstack/react-form';

export default function CompetitionPage() {
  const navigate = useNavigate();
  const competitionId = useParams<{ id: string }>().id;

  const { data: competitions = [] } = useGetCompetitionsQuery();

  const competition = competitions?.find(
    (competition) => competition.competition_id === Number(competitionId)
  );

  const defaultCompetition =
    competition ??
    ({
      name_en: '',
      competition_feed_id: '',
      name_fr: '',
      name_es: '',
      name_lt: '',
      name_ru: '',
    } as unknown as CompetitionType);

  const { mutateAsync: createCompetition } = useCreateCompetitionMutation();
  const { mutateAsync: updateCompetition } = useUpdateCompetitionMutation();

  const form = useForm({
    defaultValues: defaultCompetition,
    onSubmit: ({ value }) => {
      if (competition) {
        updateCompetition(value as CompetitionType);
        return;
      }
      createCompetition(value as CompetitionType);
    },
  });

  const [value, setValue] = useState(0);

  const handleChangeTabs = (_event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Container>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          form.handleSubmit();
        }}
      >
        <Stack
          spacing={2}
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography variant='h4' gutterBottom>
            {competition ? 'Edit Competition' : 'Create Competition'}
          </Typography>

          <Stack direction='row' spacing={2}>
            <Button
              variant='outlined'
              onClick={() => navigate('/dashboard/competitions')}
              startIcon={<Iconify icon='eva:arrow-back-outline' />}
            >
              Back
            </Button>
            <Button
              variant='contained'
              type='submit'
              startIcon={<Iconify icon='eva:save-outline' />}
            >
              {competition ? 'Update' : 'Create'}
            </Button>
          </Stack>
        </Stack>

        <Card sx={{ mt: 2, p: 2 }}>
          <LanguageTabs value={value} onChange={handleChangeTabs} />
          {visibleLanguages.map((lang, index) => (
            <TabPanel value={value} index={index} key={lang.code}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {/* @ts-ignore form error */}
                  <form.Field
                    name={`name_${lang.code}` as keyof CompetitionType}
                    children={({ state, handleChange, handleBlur }) => (
                      <TextField
                        required
                        label={`Title ${lang.label}`}
                        fullWidth
                        value={state.value}
                        onChange={(e) => handleChange(e.target.value)}
                        onBlur={handleBlur}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  {/* @ts-ignore form error */}
                  <form.Field
                    name={`competition_feed_id` as keyof CompetitionType}
                    children={({ state, handleChange, handleBlur }) => (
                      <TextField
                        required
                        label={`Feed Id`}
                        fullWidth
                        value={state.value}
                        onChange={(e) => handleChange(e.target.value)}
                        onBlur={handleBlur}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </TabPanel>
          ))}
        </Card>
      </form>
    </Container>
  );
}
